import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { logo, question } from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import "./Verification.scss";

const Verfication = () => {
  const navigate = useNavigate();
  let [params] = useSearchParams();
  const [displayMessage, setDisplayMessage] = useState();
  

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
   const body = {
      link_id: params.get('link_id'),
    };

    await httpApiCall({ api: "verify_partner_email", type: "POST", body })
      .then((data) => {
        // console.log(data);
        setDisplayMessage(data.original_text);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="login login_verification">
      <div className="login-flow-wrapper--body-card__form sign-in">
        <div className="header mb-4">
          <img src={logo} alt="" />
        </div>
        <div className="login-flow-wrapper--body-card__form-header">
          <h3 className="mb-2">
            Email Verified
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6177 21.9204H10.4639L7.75016 19.1254H3.73641L2.87516 18.3129V14.3804L0.128906 11.5854V10.4317L2.87516 7.63668V3.68793L3.73641 2.87543H7.75016L10.4639 0.0966797H11.6177L14.4127 2.87543H18.3614L19.1739 3.67168V7.63668L21.9527 10.4317V11.5854L19.1252 14.3804V18.3129L18.3127 19.1254H14.4127L11.6177 21.9204ZM8.93641 15.0304H10.0902L16.2164 8.90418L15.0627 7.75043L9.52141 13.3079L7.27891 11.0654L6.12516 12.2192L8.93641 15.0304Z"
                fill="#18B557"
              />
            </svg>
          </h3>
          <p className="display_msg">{displayMessage}</p>
          <button className="buttonm mb-4" onClick={() => navigate("/login")}>
            Login To Panel
          </button>
        </div>
      </div>
      <div className="login_end">
        <p>
          Visit
          <Link to="https://www.credee.com" target="_blank">
            Credee.com
          </Link>
          to learn about benefits for being a partner with us
        </p>
      </div>
      <div className="login_help">
        <Link to="https://www.credee.com/support" target="_blank">
          <span>
            <img src={question} alt="question" /> Help & support
          </span>
        </Link>
      </div>
    </div>
  );
};

export default Verfication;
